/**
 * 客源结构：一次拉取过去 7/30/12 月 + 未来 7/30 天五组图表
 */
import { useState, useCallback, useEffect } from 'react';
import { getCustomerSourceFromProxy, } from '../../service/storeRevenueApi';
export function pickCustomerSourceChart(bundle, range) {
    var _a, _b, _c, _d, _e;
    if (!bundle)
        return undefined;
    if (range === '7d')
        return (_a = bundle.last7Days) === null || _a === void 0 ? void 0 : _a.chartData;
    if (range === '30d')
        return (_b = bundle.last30Days) === null || _b === void 0 ? void 0 : _b.chartData;
    if (range === '12m')
        return (_c = bundle.last12Months) === null || _c === void 0 ? void 0 : _c.chartData;
    if (range === 'next7d')
        return (_d = bundle.next7Days) === null || _d === void 0 ? void 0 : _d.chartData;
    return (_e = bundle.next30Days) === null || _e === void 0 ? void 0 : _e.chartData;
}
var emptyAxes = {
    left: { id: 'left', position: 'left', name: '间夜数', unit: '间', min: 0, max: 100 },
    right: { id: 'right', position: 'right', name: '出租率', unit: '%', min: 0, max: 130 },
};
var emptyBlock = {
    chartData: {
        categories: [],
        dataset: {
            fit: [],
            team: [],
            member: [],
            unit: [],
            ota: [],
            intro: [],
            occupancyRate: [],
        },
        axes: emptyAxes,
        series: [],
    },
};
var emptyBundle = {
    last7Days: emptyBlock,
    last30Days: emptyBlock,
    last12Months: emptyBlock,
    next7Days: emptyBlock,
    next30Days: emptyBlock,
};
export function useCustomerSourceData(storeId, options) {
    var enabled = (options === null || options === void 0 ? void 0 : options.enabled) !== false;
    var _a = useState(emptyBundle), data = _a[0], setData = _a[1];
    var _b = useState(function () { return enabled; }), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(0), refreshKey = _d[0], setRefreshKey = _d[1];
    var refresh = useCallback(function () { return setRefreshKey(function (k) { return k + 1; }); }, []);
    useEffect(function () {
        if (!enabled) {
            setLoading(false);
            setError(null);
            setData(emptyBundle);
            return;
        }
        var cancelled = false;
        setLoading(true);
        setError(null);
        getCustomerSourceFromProxy(storeId)
            .then(function (res) {
            if (cancelled)
                return;
            setData(res !== null && res !== void 0 ? res : emptyBundle);
        })
            .catch(function (err) {
            if (!cancelled) {
                setError(err instanceof Error ? err : new Error(String(err)));
                setData(emptyBundle);
            }
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [storeId, enabled, refreshKey]);
    return { data: data, loading: loading, error: error, refresh: refresh };
}
